







import { Component, Vue } from 'vue-property-decorator';
import Bar from '@/components/Bar.vue'; // @ is an alias to /src
import firebase from 'firebase/app';

@Component({
  components: {
    Bar,
  },
})
export default class Home extends Vue {
  private msg = 'Welcome to Your Vue.js + TypeScript App'
  private color = '#ffffff'
  private bgColor = '#000000'

  mounted () {
    const db = firebase.firestore()
    db.collection('session').doc('ecQGbkfmg7F1xo5iVziC').onSnapshot((doc) => {
      const source = doc.metadata.hasPendingWrites ? "Local" : "Server";
      // console.log(source, " data: ", doc.data());
      const data = doc.data()
      if (!data) {
        return
      }

      const { message, fontColor, bgColor } = data
      this.msg = message
      this.color = fontColor
      this.bgColor = bgColor
    });
  }
}
